module.exports = __webpack_public_path__ + "0a458ff8c67903dee25fc32b9343072f.png";